module.exports = __webpack_public_path__ + "static/media/square-default-avatar.b8f5da31.svg";